export const POLAND_COUNTRY_CODE = 'PL'
